import LeadEnergyShield from './lead_energyshield';
export default LeadEnergyShield;
